import {createSelector} from 'reselect'
import {selectInputFieldNames} from '../../../../data/input-fields'
import {DIRECTOR_ROLES_PAGE_INPUT_FIELDS} from '../constants'

export const selectIsAnyRoleBasedFieldsVisible = createSelector(
  selectInputFieldNames,
  inputFields =>
    DIRECTOR_ROLES_PAGE_INPUT_FIELDS.some(roleBasedInputField =>
      inputFields.includes(roleBasedInputField)
    )
)
